( function() {
	'use strict';

	var hasAdminBar = document.body.classList.contains( 'admin-bar' ),
		siteHeader = document.querySelector( '.site-header' ),
		menuPrimary = document.getElementById( 'js-menu-primary-wrapper' ),
		menuLanguage = document.getElementById( 'js-menu-language' );

	if ( !hasAdminBar ) {
		return;
	}

	var trackHeader = function() {
		// 600 is the breakpoint for the WP admin bar
		if ( window.innerWidth < 600 ) {
			if ( window.scrollY < 46 ) {
				siteHeader.style.top = 46 - window.scrollY + 'px';
				menuPrimary.style.top = 77 + 46 - window.scrollY + 'px';
				// some sites don't have a language menu
				if ( menuLanguage ) {
					menuLanguage.style.top = 77 + 46 - window.scrollY + 'px';
				}
			} else {
				siteHeader.style.top = 0;
				menuPrimary.style.top = '77px';
				// some sites don't have a language menu
				if ( menuLanguage ) {
					menuLanguage.style.top = '77px';
				}
			}
		} else {
			siteHeader.style.top = '';

			if ( menuPrimary ) {
				menuPrimary.style.top = '';
			}

			// some sites don't have a language menu
			if ( menuLanguage ) {
				menuLanguage.style.top = '';
			}
		}
	};

	trackHeader();
	window.addEventListener( 'scroll', trackHeader );
	window.addEventListener( 'resize', trackHeader );

} )();
